import OverallActivityGraph from './container/OverallActivityGraphContainer'

export default OverallActivityGraph
